"use strict";
/**
 * The purpose of this file is to expose the with webpack compiled AmCharts API
 * to be able to use them with vanilla javascript.
 */


import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4maps from "@amcharts/amcharts4/maps";
//import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import * as $ from "jquery";
//import * as i18next from "i18next"; // works after we defined it externally in webpack if we load it before this file


//import pdfMake from "pdfmake/build/pdfmake";
//import pdfFonts from "pdfmake/build/vfs_fonts";
//pdfMake.vfs = pdfFonts.pdfMake.vfs;
//import {pdfMake} from "pdfmake/build/pdfmake";
/*
import * as pdfMake from "pdfmake/build/pdfmake";
import {pdfMake as pdfFonts} from "pdfmake/build/vfs_fonts";
(pdfMake as any).vfs = pdfFonts.vfs;
*/

import {PlotChartOptions, LinePlotData, ChartDetail, ChartExportOptions} from "./amcharts/structs";
import {WebHelper} from "./amcharts/WebHelper";
import {Helper} from "./amcharts/Helper";
import {time} from "@amcharts/amcharts4/core";

am4core.options.commercialLicense = true;
am4core.useTheme(am4themes_animated);


export class AmHelperClass {
    public readonly webHelper = new WebHelper();
    public readonly helper = new Helper();

    protected chartInstances: am4core.Sprite[] = [];

    constructor(/*app StayDown*/) {
        //this.app = app;
    }

    public /*static*/ getPlotChartOptions() {
        return new PlotChartOptions();
    }

    public /*static */getLoadDelayMs() {
        return 10;
    }

    public /*static */getChartExportOptions() {
        return new ChartExportOptions();
    }

    public /*static */getChartDetail(name: string, value: string, title: string, displayValue: string) {
        return new ChartDetail(name, value, title, displayValue);
    }

    public getAllCharts() {
        return this.chartInstances;
    }

    /**
     * Call this to remove all cached chart instances. Needed when adding + removing charts with JavaScript after page has been loaded.
     */
    public clearAllCharts() {
        this.chartInstances = []; // TODO could be done by listeing for a destructor/removed event?
    }

    public plotLineChart(chartID: string, xLabels: string[], dataPoints: LinePlotData, dataPointLabels: string[], chartOpts?: PlotChartOptions) {
        if (!chartOpts)
            chartOpts = new PlotChartOptions();
        if (!chartOpts.colors)
            chartOpts.colors = this.getPlainChartColors();

        let chart = am4core.create(chartID, am4charts.XYChart);
        chart.id = chartID;
        chart.legend = new am4charts.Legend();
        //chart.paddingRight = 20;

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "day";
        categoryAxis.title.text = chartOpts.xLabel ? chartOpts.xLabel : "Days";
        //let x = new am4charts.CategoryAxis();
        /*
        categoryAxis.min = 0;
        categoryAxis.max = 500;
        categoryAxis.axisBreaks
        categoryAxis.axisRanges
        */
        //categoryAxis.initRenderer();
        categoryAxis.renderer.minGridDistance = chartOpts.minGridDistance; // TODO has no effect with beta72, always 1
        categoryAxis.renderer.labels.template.rotation = chartOpts.xAxisRotation;
        //categoryAxis.renderer.labels.template.paddingTop = 35;
        categoryAxis.renderer.labels.template.paddingLeft = 25;
        //categoryAxis.renderer.labels.template.dy = 35;

        // TODO add scrollbars if we have to many x points in the chart?

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = chartOpts.yLabel ? chartOpts.yLabel : "";

        // 2nd Y axis
        let additionalValueAxis: am4charts.ValueAxis[] = []
        if (chartOpts.individualAxisStartIndex !== -1 && dataPoints.length > chartOpts.individualAxisStartIndex) {
            let addAxisCount = dataPoints.length - chartOpts.individualAxisStartIndex - 1;
            for (let i = 0; i <= addAxisCount; i++)
            {
                let valueAxisAdditional = chart.yAxes.push(new am4charts.ValueAxis());
                // we can only display 2 y axis labels, more doesn't display anymore, but useful to add a 3rd scaling
                // now working
                //valueAxisAdditional.title.text = i === 0 ? chartOpts.value2ndAxisLabel : "";
                valueAxisAdditional.title.text = chartOpts.value2ndAxisLabel.length > i ? chartOpts.value2ndAxisLabel[i] : "";
                valueAxisAdditional.renderer.opposite = true;
                if (chartOpts.axisIdPrefix) {
                    valueAxisAdditional.element.attr({"id": chartOpts.axisIdPrefix + i}); // DOM id, discouraged but the best solution atm
                    // css class name, must be unique too because treated as ID internally, spaces not possible to create class: Foo Foo1
                    //valueAxisAdditional.id = chartOpts.axisIdPrefix + i;
                    //valueAxisAdditional.uidAttr(); // not needed, removes attr() id
                    //valueAxisAdditional.setClassName();
                }
                additionalValueAxis.push(valueAxisAdditional);
            }
        }

        // Add data
        chart.data = [];
        if (dataPoints.length === 0 || Array.isArray(dataPoints[0]) !== true || dataPoints.length !== dataPointLabels.length) // convert chart.js legacy data
            return console.error("Error plotting line chart with invalid data", dataPoints, dataPointLabels);

        // iterate over the number of line series
        for (let i = 0; i < dataPoints.length; i++)
        {
            // iterate over the data for this line
            for (let u = 0; u < dataPoints[i].length; u++)
            {
                let series = {day: /*dataPointLabels[i]*/xLabels[u]};
                for (let x = 0; x < dataPoints.length; x++)
                {
                    let seriesName = "dataSeries_" + x;
                    series[seriesName] = dataPoints[x][u];
                }
                chart.data.push(series); // add this day
            }
            break; // we are done. we already added all line series data by iterating over x
        }

        // add the line series to the chart
        for (let i = 0; i < dataPointLabels.length; i++)
        {
            let series = chart.series.push(new am4charts.LineSeries());
            let amColor = am4core.color(chartOpts.colors[i]);
            series.name = dataPointLabels[i];
            series.stroke = amColor;
            series.strokeWidth = chartOpts.lineStrokeWidth;
            if (chartOpts.fillColors === true) {
                series.fill = amColor; // colors the whole area below the line
                //series.fillOpacity = 0.6;
                series.fillOpacity = 1.0;
                //series.zIndex = 100 + i;
            }
            series.dataFields.valueY = "dataSeries_" + i;
            series.dataFields.categoryX = "day";
            if (i >= chartOpts.individualAxisStartIndex) {
                const index = i - chartOpts.individualAxisStartIndex;
                series.yAxis = additionalValueAxis[index];
                if (chartOpts.seriesHidden.length >= index && chartOpts.seriesHidden[index] === true)
                    series.hidden = true;
            }

            let circleBullet = series.bullets.push(new am4charts.CircleBullet());
            circleBullet.circle.stroke = am4core.color(/*chartOpts.colors[i]*/"#fff");
            circleBullet.circle.fill = amColor;

            circleBullet.circle.strokeWidth = 1.0;
            circleBullet.circle.radius = 3;
            circleBullet.tooltipText = "{name}: [bold]{dataSeries_" + i + "}[/]";
        }

        // 2nd series
        /*
        var series2 = chart.series.push(new am4charts.LineSeries());
        series2.dataFields.valueY = "dataSeries_4";
        series2.dataFields.categoryX = "day";
        series2.name = "Price (USD)";
        series2.tooltipText = "{name}: [bold]{valueY}[/]";
        series2.strokeWidth = 3;
        series2.yAxis = valueAxis2;
        */

        if (chartOpts.cursor === true)
            chart.cursor = new am4charts.XYCursor();

        // Create series
        /*
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "litres";
        series.dataFields.categoryX = "country";
        series.name = "Sales";
        series.columns.template.tooltipText = "Series: {name}\nCategory: {categoryX}\nValue: {valueY}";
        series.columns.template.fill = am4core.color("#104547"); // fill
        */
        this.chartInstances.push(chart);
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected getPlainChartColors() {
        let colors = [
            "#ff6f74",
            "#51a423",
            "#c01bff",
            "#FFCE56",
            "#b7b9eb",
            "#fbbff2",
            "#3690d8",
            "#57e232",
            "#FF6384",
            "#a4ff38",
            "#000000",
            "#ff583d",
            "#53ffd3",
            "#ff1e1a",
            "#25cdf2",
            "#ff2af0",
            "#7cf18d",
            "#ffe847",
            "#1d3fff",
            "#daded7"
        ];
        return colors;
    }

    protected getChartColors() {
        return this.toColorSet(this.getPlainChartColors());
    }

    protected getDangerFillColor(percentage: number, startPercentage = 90, stepDownPercentage = 5, zeroColor = "#ffffff") {
        let fillCollers = [
            {min: startPercentage, color: "#b40f1f"}
        ];
        let colors = ["#e41228",
            "#f8142c",
            "#c6862f",
            "#e79d37",
            "#f4a53a",
            "#ddd83a",
            "#ebe63e",
            "#beec24",
            "#c7f726"]
        let curPercentage = startPercentage;
        for (let i = 0; i < colors.length; i++)
        {
            curPercentage -= stepDownPercentage;
            fillCollers.push({min: curPercentage, color: colors[i]});
        }
        for (let i = 0; i < fillCollers.length; i++)
        {
            if (percentage > fillCollers[i].min)
                return fillCollers[i].color;
        }
        return zeroColor;
    }

    /*
    protected addChartDefaultProps(geoData: typeof am4geodata_worldLow, props: string[]) {
        geoData = Object.assign({}, geoData);
        geoData.features.forEach((feature) => {
            props.forEach((prop) => {
                feature.properties[prop] = 0; // TODO 3rd parameter to add values
            });
        });
        return geoData;
    }
    */

    protected toColorSet(colors) {
        let colorSet = [];
        for (let i = 0; i < colors.length; i++)
            colorSet.push(am4core.color(colors[i]));
        let set = new am4core.ColorSet();
        set.list = colorSet;
        return set;
    }

    protected isEmptyDataRray(data: number[]) {
        for (let i = 0; i < data.length; i++)
        {
            if (data[i] !== 0)
                return false;
        }
        return true;
    }
}

if (window.AmHelper === undefined) // global object on window
    window.AmHelper = new AmHelperClass(/*StayDown*/);